import { createContext, useContext } from 'react';
import FilterStore from '../../Builder/ExperienceCatalog/FilterTemplate/Store';
import SortStore from '../../Builder/ExperienceCatalog/SortTemplate/Store';
import { Maybe, nothing } from 'maybeasy';
import { FilterOptionData } from '../../Builder/ExperienceCatalog/Types';
import UnlicensedToggleStore from './UnlicensedToggleStore';
import { ShowUnlicensedToggle } from './FilterOptionsTypes';

interface FilterStoresProps {
  productTypeFilterStore: FilterStore;
  durationFilterStore: FilterStore;
  schoolPartnerFilterStore: FilterStore;
  languageFilterStore: FilterStore;
  licenseFilterStore: FilterStore;
  competencyFilterStore: FilterStore;
  sortStore: SortStore;
  productTypeOptions: FilterOptionData[];
  schoolPartnerOptions: FilterOptionData[];
  languageOptions: FilterOptionData[];
  durationOptions: FilterOptionData[];
  licenseOptions: FilterOptionData[];
  competencyOptions: FilterOptionData[];
  unlicensedToggleStore: UnlicensedToggleStore;
  showUnlicensedToggle: ShowUnlicensedToggle;
}

export const FilterStores = createContext<Maybe<FilterStoresProps>>(nothing());

export const useFilterStoreContext = () => useContext(FilterStores);
